import { createAction, props } from '@ngrx/store';

export const loadAcknowledgePaymentRuns = createAction(
  '[AcknowledgePaymentRun] Load AcknowledgePaymentRuns',
  props<{ request: { businessId: string; businessPaymentRunId: string } }>()
);

export const loadAcknowledgePaymentRunsSuccess = createAction(
  '[AcknowledgePaymentRun] Load AcknowledgePaymentRuns Success',
  props<{ response: string }>()
);

export const loadAcknowledgePaymentRunsFailure = createAction(
  '[AcknowledgePaymentRun] Load AcknowledgePaymentRuns Failure',
  props<{ error: Error | any }>()
);
